const CONTEXT_PATHS = ['/tob/live/usp-core', '/tob/beta/usp-core', '/usp-core'];

const replaceContextPath = (path, includeAbsolute) => {
    if (!path) {
        return path;
    }

    let fixedPath = path;
    CONTEXT_PATHS.forEach((contextPath) => {
        const index = fixedPath.indexOf(contextPath);

        if (
            index === 0 ||
            (includeAbsolute && fixedPath.indexOf('http') === 0 && index !== -1)
        ) {
            fixedPath = fixedPath.substring(index + contextPath.length + 1);
            fixedPath = `${process.env.REACT_APP_CONTEXT}${fixedPath}`;
        }
    });

    return fixedPath;
};

export { replaceContextPath };
export default {};
